const setToInt = (value: any) => (value && parseInt(value, 10)) || value

export default setToInt
